import { tvpil } from '../compat/tvpil';
import { queryKeys } from '../queryKeys';

import { fetchChannelCollection } from './fetchChannelCollection';

type CreateChannelCollectionQueryOptionsArgs = {
  referenceId: string;
};

export function createChannelCollectionQueryOptions({ referenceId }: CreateChannelCollectionQueryOptionsArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  return {
    queryKey: queryKeys.channelCollection(referenceId),
    queryFn: () =>
      fetchChannelCollection({
        channelId: category!.channels[0],
        includeAdult: tvpil.transactionStore.isAdultEntitled,
        kSql: category!.aggregatedKSQL,
      }),
    staleTime: Infinity,
  };
}
